var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.checkBoxWrapper,on:{"click":_vm.onHandleChange}},[_c('div',{class:_vm.$style.chkIcon},[(_vm.checked)?_c('icon-checked'):_vm._e()],1),_c('div',{class:_vm.$style.chkTitle},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }